import React from "react"

import {Redirect, withRouter, Link} from "react-router-dom"
import {Form, Icon, Input, Button, Tooltip, message} from 'antd'
import {API, Auth} from "aws-amplify"

import LoginBase from './LoginBase'

import {connect} from "react-redux"
import {allState as mapStateToProps, allDispatch as mapDispatchToProps} from "../../Redux/Selectors"

const queryString = require('query-string');

class LoginForm extends React.Component {

    onSubmit(e) {

        e.preventDefault()
        this.props.form.validateFieldsAndScroll({first: true}, (err, values) => {
            if (!err) {
                this.props.CallLogin()
                this.handleSubmit(values.user.toLowerCase().replace(/\s+/g, ''), values.password)
            }
        })
    }

    async handleSubmit(email, password) {
        try {
            const user = await Auth.signIn(email, password);
            // console.log(user);

            if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                message.info("Password reset required")
                this.props.ChallengeRequested(user)
                this.props.history.push('/password-reset')
            } else if (user.challengeName === 'SMS_MFA' || user.challengeName === 'SOFTWARE_TOKEN_MFA') {
                message.info("MFA code required")
                this.props.ChallengeRequested(user)
                this.props.history.push('/mfa-login')
            } else {
                const [response, userC] = await Promise.all([
                    Auth.currentSession(),
                    Auth.currentUserInfo()
                ]);

                await API.get(
                    'test',
                    '/bot/debt/',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                ).catch(e => e);

                this.userData = await API.get(
                    'test',
                    '/root/users/' + userC.username,
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                ).catch(e => e);

                let admin = "cognito:groups" in user.signInUserSession.accessToken.payload && user.signInUserSession.accessToken.payload["cognito:groups"].includes("admin")
                let adminLite = "cognito:groups" in user.signInUserSession.accessToken.payload && user.signInUserSession.accessToken.payload["cognito:groups"].includes("adminLite")
                let adminDC = "cognito:groups" in user.signInUserSession.accessToken.payload && user.signInUserSession.accessToken.payload["cognito:groups"].includes("adminDC")
                let adminLiteDC = "cognito:groups" in user.signInUserSession.accessToken.payload && user.signInUserSession.accessToken.payload["cognito:groups"].includes("adminLiteDC")
                let analistaDC = "cognito:groups" in user.signInUserSession.accessToken.payload && user.signInUserSession.accessToken.payload["cognito:groups"].includes("analistaDC")

                const current = await Auth.currentAuthenticatedUser();
                const userLite = this.userData && this.userData.tipo_usuario === 'LITE';
                this.props.Login(current, admin, adminLite, userLite, adminDC, adminLiteDC, analistaDC);
                if (admin) {
                    this.props.history.push('/admin')
                } else if (adminDC || adminLiteDC || analistaDC) {
                    this.props.history.push('/document-control')
                } else if (adminLite) {
                        this.props.history.push('/admin-lite')
                } else if (userLite) {
                    this.props.history.push('/user-lite')
                } else {
                    if (this.props.location.pathname === '/login-mp')
                        this.props.history.push('/mp')
                    else
                        this.props.history.push('/')
                }
            }
        } catch (e) {
            if (e.code === 'UserNotConfirmedException') {
                message.info("Confirmación de cuenta de mail necesaria")
                this.props.history.push('/confirm-email?' + queryString.stringify({email: email.toLowerCase().replace(/\s+/g, '')}))
            } else if (e.code === 'PasswordResetRequiredException') {
                message.error("Por favor, recupera tu contraseña")
                this.props.history.push('/forgot-password?' + queryString.stringify({email: email.toLowerCase().replace(/\s+/g, '')}))
            } else if (e.code === 'NotAuthorizedException') {
                message.error("Password incorrecto")
            } else if (e.code === 'UserNotFoundException') {
                message.error("Usuario inexistente, registrate por favor")
            } else if (e.code === 'ResourceNotFoundException') {
                message.error('Usuario inexistente, registrate por favor - codigo: ResourceNotFoundException')
            } else if (e.code === 'TooManyRequestsException') {
                message.error('Demasiadas solicitudes para el usuario. Vuelve a intentar más tarde')
            } else if (e.code === 'UnexpectedLambdaException') {
                message.error('Lo sentimos, ocurrio un error! Codigo: UnexpectedLambdaException')
            } else if (e.code === 'UserLambdaValidationException') {
                message.error('Lo sentimos, ocurrio un error! Codigo: UserLambdaValidationException')
            } else if (e.code === 'InternalErrorException') {
                message.error('Lo sentimos, ocurrio un error! Codigo: InternalErrorException')
            } else if (e.code === 'InvalidLambdaResponseException') {
                message.error('Lo sentimos, ocurrio un error! Codigo: InvalidLambdaResponseException')
            } else if (e.code === 'InvalidParameterException') {
                message.error('Lo sentimos, ocurrio un error! Codigo: InvalidParameterException')
            } else if (e.code === 'InvalidUserPoolConfigurationException') {
                message.error('Lo sentimos, ocurrio un error! Codigo: InvalidUserPoolConfigurationException')
            } else {
                message.error('Ocurrio un error, por favor contacta a los administradores - codigo: ' + e.code, 5)
                console.log(e)
            }
            this.props.EndCallLogin()
        }
    }

    render() {
        const {getFieldDecorator} = this.props.form;

        const parsed = queryString.parse(this.props.location.search)
        let email = "email" in parsed ? parsed.email : ""

        if (this.props.login.fechingStatus === true) {
            return null;
        } else {
            return (
                <LoginBase title="Bienvenido a Liqui!" hideHomeButton>
                    <Form
                        onSubmit={(e) => this.onSubmit(e)}
                        hideRequiredMark={true}
                    >
                        <Form.Item
                            wrapperCol={
                                {
                                    xs: {
                                        span: 24,
                                        offset: 0,
                                    },
                                    sm: {
                                        span: 16,
                                        offset: 4,
                                    },
                                }
                            }
                        >
                            {
                                getFieldDecorator('user', {
                                    rules: [
                                        {
                                            required: true,
                                            type: 'email',
                                            message: 'Email válido requerido',
                                        },
                                    ],
                                    initialValue: email
                                })(<Input
                                    prefix={<Icon type="mail"/>}
                                    placeholder="Email"
                                    suffix={
                                        <Tooltip title="Ingrese su email">
                                            <Icon type="info-circle"/>
                                        </Tooltip>
                                    }
                                    autoComplete="email"
                                    //autoFocus={email===""}
                                />)
                            }
                        </Form.Item>
                        <Form.Item
                            wrapperCol={
                                {
                                    xs: {
                                        span: 24,
                                        offset: 0,
                                    },
                                    sm: {
                                        span: 16,
                                        offset: 4,
                                    }
                                }
                            }
                        >
                            {
                                getFieldDecorator('password', {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Contraseña requerida',
                                        },
                                    ],
                                })(<Input.Password
                                    prefix={<Icon type="lock"/>}
                                    placeholder="Contraseña"
                                    autoComplete="current-password"
                                    type="password"
                                    //autoFocus={email!==""}
                                />)
                            }
                        </Form.Item>
                        <Form.Item>
                            <Button
                                className="ant-btn-stepsuser"
                                onClick={(e) => this.onSubmit(e)}
                                type="primary"
                                htmlType="submit"
                                loading={this.props.login.calling}
                                //style={{backgroundColor: "#8764c8", border: "None", fontWeight: "600"}}
                            >
                                Ingresar
                            </Button>
                        </Form.Item>
                        <Link to='/sign-up'>Registrarse</Link> | <Link
                        to={"/forgot-password?" + queryString.stringify({email: this.props.form.getFieldValue('user')})}>Olvidé
                        mi contraseña</Link>
                    </Form>
                </LoginBase>
            )
        }
    }
}

const Login = Form.create({name: 'login'})(LoginForm);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));
